import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseMessageComponent } from './base-message.component';

@Component({
  selector: 'miq-text',
  template: `<p class="summary">{{ content() }}</p>`,
  styles: [
    `
      .summary {
        margin: 0;
        padding: 0;
        font-size: 14px;
        line-height: 1.5;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextComponent implements BaseMessageComponent {
  readonly content = input<string>();
}
